import type { Language } from '@application/types';
import { splitPhoneNumberIntoParts } from '@application/utils';
import type { MtSettingsBuyerGetProfileQuery } from '@gql/graphql';
import type { MtSettingsBuyerPageFormValues } from '@presentation/pages';
import dayjs from 'dayjs';
import { useMemo } from 'react';

export const useProfileInitialValuesBuilder = (
  profile: MtSettingsBuyerGetProfileQuery['accountMe'] | null | undefined,
) => {
  const initialValues = useMemo((): MtSettingsBuyerPageFormValues => {
    let phonePrefix;
    let phoneWithoutprefix;
    if (profile?.phone) {
      const { phoneNumberWithoutPrefix, phonePrefixCountry } = splitPhoneNumberIntoParts(
        profile.phone,
      );
      phonePrefix = phonePrefixCountry;
      phoneWithoutprefix = phoneNumberWithoutPrefix;
    }

    return {
      firstName: profile?.firstName ?? undefined,
      lastName: profile?.lastName ?? undefined,
      phone: phoneWithoutprefix,
      phonePrefixCountry: phonePrefix,
      email: profile?.email ?? undefined,
      birthday: profile?.birthday ? dayjs(profile.birthday) : undefined,
      language: (profile?.language as Language) ?? undefined,
      gender: profile?.gender ?? undefined,
      image: profile?.imgs?.[0]?.small ?? undefined,
      contactPreferences: profile?.contactPreferences ?? undefined,
    };
  }, [
    profile?.birthday,
    profile?.firstName,
    profile?.gender,
    profile?.imgs,
    profile?.language,
    profile?.lastName,
    profile?.phone,
    profile?.email,
    profile?.contactPreferences,
  ]);

  return { initialValues };
};
